import React from "react";
import type { SwitchProps } from "@material-ui/core";
import { Switch } from "@material-ui/core";

import useStyles from "./PageToggle.styles";

const PageToggle = (props: SwitchProps): React.ReactElement => {
  const classes = useStyles();

  return (
    <Switch
      disableRipple
      classes={{
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
        root: classes.root,
      }}
      {...props}
    />
  );
};

export default PageToggle;
